export const CONSENT_LIST_REQUEST = 'CONSENT_LIST_REQUEST';
export const CONSENT_LIST_SUCCESS = 'CONSENT_LIST_SUCCESS';
export const CONSENT_LIST_FAIL = 'CONSENT_LIST_FAIL';

export const CONSENT_DETAILS_REQUEST = 'CONSENT_DETAILS_REQUEST';
export const CONSENT_DETAILS_SUCCESS = 'CONSENT_DETAILS_SUCCESS';
export const CONSENT_DETAILS_FAIL = 'CONSENT_DETAILS_FAIL';
export const CONSENT_DETAILS_RESET = 'CONSENT_DETAILS_RESET';

export const CONSENT_CREATE_REQUEST = 'CONSENT_CREATE_REQUEST';
export const CONSENT_CREATE_SUCCESS = 'CONSENT_CREATE_SUCCESS';
export const CONSENT_CREATE_FAIL = 'CONSENT_CREATE_FAIL';
export const CONSENT_CREATE_RESET = 'CONSENT_CREATE_RESET';

export const CONSENT_UPDATE_REQUEST = 'CONSENT_UPDATE_REQUEST';
export const CONSENT_UPDATE_SUCCESS = 'CONSENT_UPDATE_SUCCESS';
export const CONSENT_UPDATE_FAIL = 'CONSENT_UPDATE_FAIL';
export const CONSENT_UPDATE_RESET = 'CONSENT_UPDATE_RESET';

export const CONSENT_DELETE_REQUEST = 'CONSENT_DELETE_REQUEST';
export const CONSENT_DELETE_SUCCESS = 'CONSENT_DELETE_SUCCESS';
export const CONSENT_DELETE_FAIL = 'CONSENT_DELETE_FAIL';

export const CONSENT_DTO_REQUEST = 'CONSENT_DTO_REQUEST';
export const CONSENT_DTO_SUCCESS = 'CONSENT_DTO_SUCCESS';
export const CONSENT_DTO_FAIL = 'CONSENT_DTO_FAIL';
export const CONSENT_DTO_RESET = 'CONSENT_DTO_RESET';

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'; 